import { render, staticRenderFns } from "./MdrlEditAbout.vue?vue&type=template&id=a84ad16c&scoped=true&"
import script from "./MdrlEditAbout.vue?vue&type=script&lang=js&"
export * from "./MdrlEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84ad16c",
  null
  
)

export default component.exports